import { Fragment, useEffect, useState } from "react";

// ui
import {
  Button,
  Typography,
  Modal,
  Box,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Alert,
  FormControl,
  Select,
  MenuItem,
  Autocomplete,
  TextField,
  FormHelperText,
} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

// API
import { getSampleCSV } from "../api/presignedURL";
import { useWindowSize } from "../lib/useWindowSize";

// CSVカラム
const putCSVColumnContractNumber = [
  "申込番号",
  "支払方法",
  "リストID",
  "申込日",
  "開通日",
  "解約日",
  "ステータス",
  "顧客・契約情報",
  "取込を行わない",
];
const putCSVColumnPhoneNumber = [
  "顧客電話番号",
  "支払方法",
  "リストID",
  "申込日",
  "開通日",
  "解約日",
  "ステータス",
  "顧客・契約情報",
  "取込を行わない",
];

// CSVカラム（結果）
const putCSVColumnResultContractNumber = [
  "申込番号",
  "支払方法",
  "リストID",
  "申込日",
  "開通日",
  "解約日",
  "ステータス",
];
const putCSVColumnResultPhoneNumber = [
  "顧客電話番号",
  "支払方法",
  "リストID",
  "申込日",
  "開通日",
  "解約日",
  "ステータス",
];

interface PostCSVContractStatusModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  postCSVStatus: {
    status:
      | "none"
      | "open"
      | "column"
      | "posting"
      | "result"
      | "loading"
      | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
    destination_key: string;
    product_id: null | number;
    product_key: string;
    header_inf: {
      [key: string]: string;
    };
  };
  setPostCSVStatus: (status: {
    status:
      | "none"
      | "open"
      | "column"
      | "posting"
      | "result"
      | "loading"
      | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
    destination_key: string;
    product_id: null | number;
    product_key: string;
    header_inf: {
      [key: string]: string;
    };
  }) => void;
  postCSVFunc: (postDatas: File) => void;
  startPutCSVFunc: () => void;
  postCSVTitle: string;
  productList: {
    id: number;
    high_rank_company_id: number;
    product_name: string;
    high_rank_company_name: string;
    product_key: string;
  }[];
  postCSVStatusHeader: string[];
}

export function PostCSVContractStatusModal(
  props: PostCSVContractStatusModalProps
) {
  const {
    onModal,
    swCloseModal,
    postCSVStatus,
    setPostCSVStatus,
    postCSVFunc,
    startPutCSVFunc,
    postCSVTitle,
    productList,
    postCSVStatusHeader,
  } = props;
  async function handleFileChange(
    event_file: React.ChangeEvent<HTMLInputElement>
  ) {
    if (event_file.target.files && event_file.target.files.length > 0) {
      const file = event_file.target.files[0];
      postCSVFunc(file);
    }
    // ファイル入力の値をリセットする
    event_file.target.files = null;
  }
  const { windowWidth, windowHeight } = useWindowSize();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: windowWidth > 868 ? "800px" : "calc(100% - 82px)",
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const [postCSVColumn, setPostCSVColumn] = useState<string[]>([]);
  const [postCSVColumnResult, setPostCSVColumnResult] = useState<string[]>([]);

  const [postCSVProductName, setPostCSVProductName] = useState<string>("");
  const autocompleteProductList: string[] = productList.map((product) => {
    return product.high_rank_company_name === "-"
      ? product.product_name
      : product.high_rank_company_name + "/" + product.product_name;
  });

  useEffect(() => {
    let product_id: null | number = null;
    let product_key: string = "";
    productList.map((product) => {
      const _postCSVProductName =
        product.high_rank_company_name === "-"
          ? product.product_name
          : product.high_rank_company_name + "/" + product.product_name;
      if (postCSVProductName === _postCSVProductName) {
        product_id = product.id;
        product_key = product.product_key;
      }
    });
    if (product_key === "申込番号") {
      setPostCSVColumn(putCSVColumnContractNumber);
    } else if (product_key === "顧客電話番号") {
      setPostCSVColumn(putCSVColumnPhoneNumber);
    }
    setPostCSVStatus({
      ...postCSVStatus,
      product_id,
      product_key,
    });
  }, [postCSVProductName]);

  const [onPostBottun, setOnPostBottun] = useState(true);
  useEffect(() => {
    let onPostBottun = true;
    let putCSVColumn =
      postCSVStatus.product_key === "申込番号"
        ? putCSVColumnContractNumber
        : postCSVStatus.product_key === "顧客電話番号"
        ? putCSVColumnPhoneNumber
        : [];
    let putCSVColumnResult: string[] = [];
    const putCSVColumnResultAll =
      postCSVStatus.product_key === "申込番号"
        ? putCSVColumnResultContractNumber
        : postCSVStatus.product_key === "顧客電話番号"
        ? putCSVColumnResultPhoneNumber
        : [];
    postCSVStatusHeader.map((csvHeader) => {
      if (
        postCSVStatus.product_key === "申込番号" &&
        postCSVStatus.header_inf[csvHeader] === "申込番号"
      ) {
        onPostBottun = false;
      } else if (
        postCSVStatus.product_key === "顧客電話番号" &&
        postCSVStatus.header_inf[csvHeader] === "顧客電話番号"
      ) {
        onPostBottun = false;
      }
      putCSVColumn = putCSVColumn.filter((column) => {
        return (
          column !== postCSVStatus.header_inf[csvHeader] ||
          column === "顧客・契約情報" ||
          column === "取込を行わない"
        );
      });

      // CSV取込後のエラー表示時の項目
      if (putCSVColumnResultAll.includes(postCSVStatus.header_inf[csvHeader])) {
        putCSVColumnResult.push(postCSVStatus.header_inf[csvHeader]);
      }
    });
    setPostCSVColumn(putCSVColumn);
    setOnPostBottun(onPostBottun);
    setPostCSVColumnResult(putCSVColumnResult);
  }, [postCSVStatus]);

  async function downloadErrorList() {
    setPostCSVStatus({
      ...postCSVStatus,
      status: "loading",
    });
    const header_location = postCSVStatus.header_location;
    if (header_location != "None") {
      const url = header_location;
      const link = document.createElement("a");
      link.href = header_location;
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(url);
      link.parentNode?.removeChild(link);
    }
    setPostCSVStatus({
      ...postCSVStatus,
      status: "result",
    });
  }

  return (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          style={{
            fontSize: "18px",
            color: "rgb(50 50 50)",
          }}
          key="serchTitleBox"
          className="shippori-antique-regular"
        >
          {postCSVTitle}
        </Box>
        {postCSVStatus.status === "open" ? (
          <Typography
            id="modal-modal-description"
            sx={{
              mt: 2,
              mb: 5,
              maxHeight: windowWidth > 385 ? undefined : "calc(70vh - 30px)",
              overflowY: windowWidth > 385 ? undefined : "auto",
            }}
          >
            <Paper elevation={0}>
              <Box
                sx={{
                  maxHeight:
                    windowWidth > 385 ? "calc(70vh - 80px)" : undefined,
                  overflowY: windowWidth > 385 ? "auto" : undefined,
                }}
              >
                <Box key={"csvProduct"}>
                  <Box className="serch-label">取込商材選択</Box>
                  <Autocomplete
                    sx={{
                      marginTop: "10px",
                      height: "50px",
                      textAlign: "end",
                      width: "calc(100%)",
                    }}
                    clearIcon={null}
                    options={autocompleteProductList}
                    value={postCSVProductName}
                    onChange={(event: any, newValue: string | null) => {
                      if (newValue) {
                        setPostCSVProductName(newValue);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        value={postCSVProductName}
                        sx={{
                          "& .MuiInputBase-root": {
                            fontSize: "16px",
                            height: "32px",
                          },
                        }}
                        {...params}
                      />
                    )}
                  />
                </Box>
              </Box>
            </Paper>
            <Box style={{ display: windowWidth > 385 ? "flex" : undefined }}>
              <Box
                style={{
                  marginTop: "10px",
                  height: "40px",
                  width:
                    windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                  marginLeft: windowWidth > 385 ? undefined : "5px",
                }}
              >
                <input
                  disabled={
                    postCSVStatus.product_id === null &&
                    postCSVStatus.product_key === ""
                  }
                  accept=".csv"
                  style={{ display: "none" }}
                  id="raised-button-file"
                  type="file"
                  onChange={(e) => handleFileChange(e)}
                />
                <label htmlFor="raised-button-file">
                  <Button
                    disabled={
                      postCSVStatus.product_id === null &&
                      postCSVStatus.product_key === ""
                    }
                    variant="outlined"
                    style={{
                      height: "40px",
                      width: "100%",
                      textTransform: "none",
                    }}
                    component="span"
                  >
                    CSV読取
                    <AttachFileIcon
                      sx={{ marginTop: "-2.5px", marginLeft: "6px" }}
                      fontSize="medium"
                    />
                  </Button>
                </label>
              </Box>
              <Box
                style={{
                  marginTop: "10px",
                  height: "40px",
                  width:
                    windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                  marginLeft: windowWidth > 385 ? "10px" : "5px",
                }}
              >
                <Button
                  variant="outlined"
                  style={{
                    height: "40px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    swCloseModal();
                    setPostCSVProductName("");
                  }}
                >
                  キャンセル
                </Button>
              </Box>
            </Box>
          </Typography>
        ) : postCSVStatus.status === "column" ? (
          <Typography
            id="modal-modal-description"
            sx={{
              mt: 2,
              mb: 5,
              maxHeight: windowWidth > 385 ? undefined : "calc(70vh - 30px)",
              overflowY: windowWidth > 385 ? undefined : "auto",
            }}
          >
            <Paper elevation={0}>
              <Box
                sx={{
                  maxHeight:
                    windowWidth > 385 ? "calc(70vh - 80px)" : undefined,
                  overflowY: windowWidth > 385 ? "auto" : undefined,
                }}
              >
                <Box key={"csvColumn"}>
                  <Box className="serch-label">CSV項目一覧</Box>
                  <FormHelperText
                    id="serch-name"
                    sx={{
                      width: "calc(100% - 10px)",
                      textAlign: "right",
                      marginRight: "5px",
                    }}
                  >
                    ※何も選択していないCSV項目は「取込を行わない」として処理されます
                    <br />
                    {postCSVStatus.product_key === "申込番号"
                      ? "※「申込番号」の選択は必須です"
                      : postCSVStatus.product_key === "顧客電話番号"
                      ? "※「顧客電話番号」の選択は必須です"
                      : ""}
                  </FormHelperText>
                  {postCSVStatusHeader.map((header) => {
                    return (
                      <>
                        <Box className="serch-label">{header}</Box>
                        <Autocomplete
                          sx={{
                            marginTop: "10px",
                            height: "50px",
                            textAlign: "end",
                            width: "calc(100%)",
                          }}
                          clearIcon={null}
                          options={postCSVColumn}
                          value={postCSVStatus.header_inf[header]}
                          onChange={(event: any, newValue: string | null) => {
                            if (newValue) {
                              let header_inf = postCSVStatus.header_inf;
                              header_inf[header] = newValue;
                              setPostCSVStatus({
                                ...postCSVStatus,
                                header_inf,
                              });
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              value={postCSVStatus.header_inf[header]}
                              sx={{
                                "& .MuiInputBase-root": {
                                  fontSize: "16px",
                                  height: "32px",
                                },
                              }}
                              {...params}
                            />
                          )}
                        />
                      </>
                    );
                  })}
                </Box>
              </Box>
            </Paper>
            <Box style={{ display: windowWidth > 385 ? "flex" : undefined }}>
              <Box
                style={{
                  marginTop: "10px",
                  height: "40px",
                  width:
                    windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                  marginLeft: windowWidth > 385 ? undefined : "5px",
                }}
              >
                <Button
                  disabled={onPostBottun}
                  variant="outlined"
                  style={{
                    height: "40px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  component="span"
                  onClick={startPutCSVFunc}
                >
                  取込開始
                </Button>
              </Box>
              <Box
                style={{
                  marginTop: "10px",
                  height: "40px",
                  width:
                    windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                  marginLeft: windowWidth > 385 ? "10px" : "5px",
                }}
              >
                <Button
                  variant="outlined"
                  style={{
                    height: "40px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    setPostCSVStatus({
                      ...postCSVStatus,
                      status: "open",
                    });
                  }}
                >
                  戻る
                </Button>
              </Box>
            </Box>
          </Typography>
        ) : postCSVStatus.status === "posting" ? (
          <Typography
            id="modal-modal-description"
            sx={{
              mt: 2,
              mb: 5,
              maxHeight: windowWidth > 385 ? undefined : "calc(70vh - 30px)",
              overflowY: windowWidth > 385 ? undefined : "auto",
            }}
          >
            <Paper elevation={0}>
              <Box
                sx={{
                  maxHeight:
                    windowWidth > 385 ? "calc(70vh - 80px)" : undefined,
                  overflowY: windowWidth > 385 ? "auto" : undefined,
                }}
              >
                <Box sx={{ textAlign: "center" }}>{postCSVStatus.message}</Box>
              </Box>
            </Paper>
          </Typography>
        ) : postCSVStatus.status === "error" ? (
          <Typography
            id="modal-modal-description"
            sx={{
              mt: 2,
              mb: 5,
              maxHeight: windowWidth > 385 ? undefined : "calc(70vh - 30px)",
              overflowY: windowWidth > 385 ? undefined : "auto",
            }}
          >
            <Paper elevation={0}>
              <Box
                sx={{
                  maxHeight:
                    windowWidth > 385 ? "calc(70vh - 80px)" : undefined,
                  overflowY: windowWidth > 385 ? "auto" : undefined,
                }}
              >
                <Alert severity="error">
                  <Box>CSVの取込に失敗しました。</Box>
                  <Box sx={{ marginTop: "15px" }}>
                    ・質問名が異なる可能性があります。
                  </Box>
                  <Box sx={{ textAlign: "center" }}>
                    {postCSVStatus.message}
                  </Box>
                </Alert>
                <Button
                  variant="outlined"
                  style={{
                    marginTop: "15px",
                    height: "40px",
                    position: "absolute",
                    right: "45px",
                    width: "160px",
                    fontSize: "20px",
                  }}
                  onClick={() => {
                    setPostCSVStatus({
                      status: "open",
                      message: "",
                      result: [],
                      header_location: "None",
                      destination_key: "",
                      product_id: null,
                      product_key: "",
                      header_inf: {},
                    });
                  }}
                >
                  戻る
                </Button>
              </Box>
            </Paper>
          </Typography>
        ) : postCSVStatus.status === "result" ? (
          <Typography
            id="modal-modal-description"
            sx={{
              mt: 2,
              mb: 5,
              maxHeight: windowWidth > 385 ? undefined : "calc(70vh - 30px)",
              overflowY: windowWidth > 385 ? undefined : "auto",
            }}
          >
            <Paper elevation={0}>
              <Box
                sx={{
                  maxHeight:
                    windowWidth > 385 ? "calc(70vh - 80px)" : undefined,
                  overflowY: windowWidth > 385 ? "auto" : undefined,
                }}
              >
                <Box>{postCSVStatus.message}</Box>
                {postCSVStatus.result.length > 0 ? (
                  <Box sx={{ marginTop: "15px" }}>
                    <Alert severity="error">
                      ※以下データ登録時にエラーが発生しました。
                    </Alert>

                    <TableContainer
                      component={Paper}
                      sx={{
                        margin: "1px 1px",
                        width: "calc(100% - 4px)",
                        maxHeight: "calc(70vh - 180px)",
                        border: "1px solid rgb(230, 230, 230)",
                      }}
                    >
                      <Table
                        stickyHeader
                        size="small"
                        aria-label="collapsible table"
                      >
                        <TableHead>
                          <TableRow key="errorCSVTableRow">
                            <TableCell
                              key={"errorCSVTableMessage"}
                              align="center"
                              sx={{
                                minWidth: "220px",
                              }}
                            >
                              エラーメッセージ
                            </TableCell>
                            {postCSVColumnResult.map((column, i) => {
                              return (
                                <TableCell
                                  key={"errorCSVTableColumn" + i}
                                  align="center"
                                  sx={{
                                    minWidth: "120px",
                                  }}
                                >
                                  {column}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {postCSVStatus.result.map((result, i) => (
                            <Fragment key={"errorCSVTableFragment" + i}>
                              <TableRow>
                                <TableCell
                                  key={"errorCSVTableCell" + i}
                                  align="center"
                                  sx={{
                                    minWidth: "220px",
                                  }}
                                >
                                  {result.message}
                                </TableCell>
                                {postCSVColumnResult.map((column, column_i) => {
                                  return (
                                    <TableCell
                                      key={
                                        "errorCSVTableColumn" +
                                        i +
                                        "Data" +
                                        column_i
                                      }
                                      align="center"
                                      sx={{
                                        minWidth: "120px",
                                      }}
                                    >
                                      {result.postData[column]}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                            </Fragment>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                ) : null}
                {postCSVStatus.header_location != "None" ? (
                  <Button
                    variant="outlined"
                    style={{
                      marginTop: "15px",
                      height: "40px",
                      position: "absolute",
                      right: "220px",
                      width: "280px",
                      fontSize: "20px",
                    }}
                    onClick={downloadErrorList}
                  >
                    エラー内容ダウンロード
                  </Button>
                ) : null}
                <Button
                  variant="outlined"
                  style={{
                    marginTop: "15px",
                    height: "40px",
                    position: "absolute",
                    right: "45px",
                    width: "160px",
                    fontSize: "20px",
                  }}
                  onClick={() => {
                    swCloseModal();
                    setPostCSVProductName("");
                  }}
                >
                  閉じる
                </Button>
              </Box>
            </Paper>
          </Typography>
        ) : null}
      </Box>
    </Modal>
  );
}
